import React from 'react';
import TextField from '@material-ui/core/TextField';

const StandardInput = ({
  errorMessage = '',
  label = '',
  endAdornment = null,
  readOnly = false,
  disabled = false,
  maxLength = null,
  ...restProps
}) => {
  return (
    <TextField
      label={label}
      helperText={errorMessage}
      InputProps={{
        endAdornment: endAdornment,
        readOnly: readOnly,
        disabled: disabled,
      }}
      inputProps={{
        maxLength: maxLength,
      }}
      disabled={disabled}
      {...restProps}
    />
  );
};

export { StandardInput };
